(function() {
  'use strict';

  var grid = document.querySelector('.grid--view-items');
  if (!grid) return;

  var INITIAL_SHOW = 18;
  var BATCH_SIZE = 6;
  var buffer = [];
  var loading = false;

  var btn = document.querySelector('.kc-load-more__btn');
  var nextUrl = btn ? btn.getAttribute('data-next-url') : null;
  var totalPages = btn ? parseInt(btn.getAttribute('data-total-pages'), 10) : 1;
  var currentPage = btn ? parseInt(btn.getAttribute('data-current-page'), 10) : 1;

  var allItems = grid.querySelectorAll(':scope > .grid__item');
  for (var i = INITIAL_SHOW; i < allItems.length; i++) {
    allItems[i].style.display = 'none';
    buffer.push(allItems[i]);
  }

  if (!btn && (buffer.length > 0 || nextUrl)) {
    var wrap = document.createElement('div');
    wrap.className = 'kc-load-more';
    btn = document.createElement('button');
    btn.className = 'kc-load-more__btn';
    btn.textContent = 'Ver más';
    wrap.appendChild(btn);
    grid.parentNode.insertBefore(wrap, grid.nextSibling);
  }

  if (!btn) return;

  if (buffer.length === 0 && !nextUrl) {
    btn.classList.add('kc-load-more__btn--hidden');
  }

  function showFromBuffer() {
    var batch = buffer.splice(0, BATCH_SIZE);
    batch.forEach(function(item) {
      if (!item.parentNode || item.parentNode !== grid) {
        grid.appendChild(item);
      }
      item.style.display = '';
    });

    if (window.lazySizes) {
      lazySizes.autoSizer.checkElems();
    }

    if (buffer.length === 0 && !nextUrl) {
      btn.classList.add('kc-load-more__btn--hidden');
    } else {
      btn.textContent = 'Ver más';
    }
  }

  function fetchNextPage(callback) {
    if (!nextUrl) {
      callback();
      return;
    }

    fetch(nextUrl)
      .then(function(res) { return res.text(); })
      .then(function(html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var newItems = doc.querySelectorAll('.grid--view-items > .grid__item');
        newItems.forEach(function(item) {
          buffer.push(item);
        });

        currentPage++;
        var newBtn = doc.querySelector('.kc-load-more__btn');
        if (newBtn && newBtn.getAttribute('data-next-url')) {
          nextUrl = newBtn.getAttribute('data-next-url');
        } else {
          nextUrl = null;
        }

        callback();
      })
      .catch(function() {
        loading = false;
        btn.classList.remove('kc-load-more__btn--loading');
        btn.textContent = 'Ver más';
      });
  }

  function loadMore() {
    if (loading) return;

    if (buffer.length >= BATCH_SIZE) {
      showFromBuffer();
      return;
    }

    if (buffer.length > 0 && !nextUrl) {
      showFromBuffer();
      return;
    }

    if (!nextUrl) {
      btn.classList.add('kc-load-more__btn--hidden');
      return;
    }

    loading = true;
    btn.classList.add('kc-load-more__btn--loading');
    btn.textContent = 'Cargando…';

    fetchNextPage(function() {
      loading = false;
      btn.classList.remove('kc-load-more__btn--loading');
      showFromBuffer();
    });
  }

  btn.addEventListener('click', loadMore);

  /* Auto-carga al acercarse al final: en el heatmap móvil (Clarity, 1-18 jul)
     el botón "Ver más" concentraba el 50% de los taps del catálogo
     (2.240 de 4.442) — la gente paginaba a mano para ver los productos.
     Ahora los lotes entran solos antes de llegar al botón; el botón queda
     de respaldo para navegadores sin IntersectionObserver. */
  if ('IntersectionObserver' in window) {
    var autoIO = new IntersectionObserver(function(entries) {
      entries.forEach(function(e) {
        if (e.isIntersecting && !btn.classList.contains('kc-load-more__btn--hidden')) {
          loadMore();
        }
      });
    }, { rootMargin: '600px 0px' });
    autoIO.observe(btn);
  }
})();
